<template>
    <section class="form">
        <form @submit.prevent="addNewBrewery" class="form-beer">
            <h1>Add Brewery</h1>
            <div class="alert alert-info" role="alert">Note: Breweries must be approved by the Admin. (For this demo, log in as the admin to approve)</div>
            <label for="name" class="sr-only">Name: </label>
            <input id="name" v-model="brewery.breweryName" placeholder="Name" type="text" />
            <label for="url" class="sr-only">Image URL: </label>
            <input id="url" v-model="brewery.imageURL" placeholder="Image URL" type="text" />
            <label for="phone" class="sr-only">Phone Number</label>
            <input id="phone" v-model="brewery.phoneNumber" placeholder="Phone Number" type="text" />
            <label for="address" class="sr-only">Address</label>
            <input id="address" v-model="brewery.address" placeholder="Address" type="text" />
            <label for="description" class="sr-only">description: </label>
            <textarea id="description" v-model="brewery.description" placeholder="Description" type="text"></textarea>
            <label for="hours" class="sr-only">Hours: </label>
            <input id="hours" v-model="brewery.hours" placeholder="hours" type="text" />
            <div>
                <button type="submit" class="button">Submit</button>
                <button v-on:click.prevent="resetForm" class="button">Cancel</button>
            </div>
        </form>
    </section>
</template>

<script>
export default {
    name: "brewery-form-view",
    data() {
        return {
            brewery: {
                breweryId: this.$store.getters.getNextBreweryId,
                breweryName: "",
                imageURL: "",
                phoneNumber: "",
                address: "",
                description: "",
                is_approved: false,
                owner: this.$store.getters.getUserIdByUsername,
                hours: "",
            },
        };
    },
    methods: {
        resetForm() {
            this.brewery = {
                breweryId: this.$store.getters.getNextBreweryId,
                breweryName: "",
                imageURL: "",
                phoneNumber: "",
                address: "",
                description: "",
                is_approved: false,
                owner: this.$store.getters.getUserIdByUsername,
                hours: "",
            }
        },
        addNewBrewery() {
            this.$store.commit("ADD_BREWERY",this.brewery);
            this.$router.push("/");
        }
    }
};
</script>
